import { render, staticRenderFns } from "./NotificationStaffTotalModal.html?vue&type=template&id=15cdcb39&external"
import script from "./NotificationStaffTotalModal.ts?vue&type=script&lang=ts&external"
export * from "./NotificationStaffTotalModal.ts?vue&type=script&lang=ts&external"
import style0 from "./NotificationStaffTotalModal.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports